import { ROLES } from '../models';

export const DEFAULT_ROLE = ROLES.CONTRIBUTOR;
